import { DataElementForTable } from '../domain/schemas';

import { parseNumber } from './parseNumber';

/**
 * ヒートマップの背景色を追加する(台別データ推移)
 * @param borderNumbers 閾値の配列
 * @param heatmapColumnIndices ヒートマップ対象列のインデックス
 */
export const addBackgroundColor =
  (borderNumbers: number[][], heatmapColumnIndices: number[]) =>
  (data: DataElementForTable[]) => {
    if (!data) {
      return data;
    }

    return data.map((x: DataElementForTable, index: number) => {
      const targetIndex = heatmapColumnIndices.indexOf(index);
      // ヒートマップ対象列でなければそのまま返す
      if (targetIndex === -1) {
        return x;
      }

      // ボーダーの値を取得
      const [top, bottom] = borderNumbers[targetIndex];
      const val = parseNumber(x.value);

      if (Number.isNaN(val)) {
        return x;
      }

      // topとbottomが同じ値の場合は背景色をつけない
      if (top === bottom) {
        return x;
      }

      const backgroundColor = () => {
        if (val >= top) {
          return '#d7eefd';
        }
        if (val <= bottom) {
          return '#fddddb';
        }
        return 'inherit';
      };

      return {
        ...x,
        backgroundColor: backgroundColor(),
      };
    });
  };
